module.exports = global["ES6Promise"] = require("-!/home/runner/work/consumer/consumer/node_modules/babel-loader/lib/index.js??ref--4!./es6-promise.min.js");